import styled from 'styled-components';

export const AdminAccessDialogWrapper = styled.div`

  s-dialog {
    width: 404px;
  }
  
  s-icon {
    margin-right: .4rem;
  }
`;
